module.exports = __webpack_public_path__ + "static/media/hkpz.8e418fc6.png";